module.exports = __webpack_public_path__ + "img/MBT_R_SE.3fbd9569.png";